export default __webpack_public_path__ + "static/media/white-arrow-up.567242e7.svg";